import type { IntegrationScope } from "schemas/generated/agentIntegration";

import * as React from "react";

import { Link2 } from "lucide-react";

export type AgentIntegrationUiKey = "google-calendar" | "notion";

export type AgentIntegrationDefinition = {
  key: AgentIntegrationUiKey;
  title: string;
  description: string;
  image: string;
  scope: IntegrationScope;
  requiresAgentEnabled?: boolean;
};

export const AGENT_INTEGRATIONS: AgentIntegrationDefinition[] = [
  {
    key: "google-calendar",
    title: "Google Calendar",
    description: "Schedule and manage events directly through Replo Agent.",
    image: "/images/integration/logos/googlecalendar.svg",
    scope: { user: true },
    requiresAgentEnabled: true,
  },
  {
    key: "notion",
    title: "Notion",
    description: "Search, create, and update Notion pages with Replo Agent.",
    image: "/images/integration/logos/notion.svg",
    scope: { project: true },
    requiresAgentEnabled: true,
  },
];

export function getAgentIntegrationByKey(key: string) {
  return AGENT_INTEGRATIONS.find((integration) => integration.key === key);
}

export function getAgentIntegrationIcon(
  integrationKey: AgentIntegrationUiKey,
): React.ReactNode {
  const integrationDefinition = getAgentIntegrationByKey(integrationKey);
  if (integrationDefinition) {
    return (
      <img
        src={integrationDefinition.image}
        alt={`${integrationDefinition.title} logo`}
        className="size-6 object-contain"
      />
    );
  }
  return <Link2 size={18} className="text-muted" />;
}
